/*
 * Copyright © 2020-2026 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 水印编辑器状态管理 Slice（完全移除 Immutable.js）
 * @LastEditors: refactor
 * @LastEditTime: 2026-03-25
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import actionTypes from '../constants/actionTypes'

// 地理位置项类型
interface GeoItem {
  watermarkID: string
  itemID: number | string
  content: string
  uploadLocation: Array<{ lat: string; lng: string }>
}

// 级联选项子项类型
interface CascadeChildItem {
  content: string
  childs?: CascadeChildItem[]
}

// 级联选项类型
interface CascadeItem {
  itemId: number | string
  records: CascadeChildItem[]
}

// State 类型 - 使用普通 JS 对象
interface WatermarkEditorState {
  watermark: any | null // 水印数据对象
  activeItem: string | number
  expandedPanels: string[] // 展开的面板 ID 列表
  geoItemsList: GeoItem[] // 地理位置关联选项列表
  cascadeItems: CascadeItem[] // 级联选项列表
}

const initialState: WatermarkEditorState = {
  watermark: null,
  activeItem: '',
  expandedPanels: [],
  geoItemsList: [],
  cascadeItems: []
}

const watermarkEditorSlice = createSlice({
  name: 'editor',
  initialState,
  reducers: {
    setEditorWatermark: (state, action: PayloadAction<any>) => {
      state.watermark = action.payload
    },

    setEditorActiveItem: (state, action: PayloadAction<string | number>) => {
      state.activeItem = action.payload
    },

    setExpandedPanels: (state, action: PayloadAction<string[]>) => {
      state.expandedPanels = action.payload
    },

    setEditorGeoItemsList: (state, action: PayloadAction<GeoItem[]>) => {
      state.geoItemsList = action.payload
    },

    setCascadeItemsList: (state, action: PayloadAction<CascadeItem[]>) => {
      state.cascadeItems = action.payload
    },

    clearEditor: () => initialState
  },
  extraReducers: (builder) => {
    // 兼容旧的 action types，保证其他地方 dispatch 旧 action 仍然有效
    builder
      .addCase(actionTypes.SET_EDITOR_WATERMARK, (state, action: any) => {
        state.watermark = action.data
      })
      .addCase(actionTypes.SET_EDITOR_ACTIVE_ITEM, (state, action: any) => {
        state.activeItem = action.data
      })
      .addCase(actionTypes.SET_EXPANDED_PANELS, (state, action: any) => {
        state.expandedPanels = action.data
      })
      .addCase(actionTypes.SET_EDITOR_GEO_ITEMS_LIST, (state, action: any) => {
        state.geoItemsList = action.data
      })
      .addCase(actionTypes.SET_CASCADE_ITEMS_LIST, (state, action: any) => {
        state.cascadeItems = action.data
      })
      .addCase(actionTypes.CLEAR_EDITOR, () => initialState)
  }
})

export const {
  setEditorWatermark,
  setEditorActiveItem,
  setExpandedPanels,
  setEditorGeoItemsList,
  setCascadeItemsList,
  clearEditor
} = watermarkEditorSlice.actions

export default watermarkEditorSlice.reducer
